var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSchool = function SvgSchool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "school_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "school_svg__st0",
    d: "M59.8 58.1h-3.3v-29h3.6c1-.1 1.8-1 1.8-2V27c.1-.8-.2-1.7-.9-2.2L33.3 2.4c-.1-.1-.2-.2-.3-.2l-.1-.1h-.1c-.1 0-.2-.1-.4-.1h-1c-.1 0-.3.1-.4.1-.3 0-.5.2-.6.4L3 24.7c-.6.5-1 1.5-.9 2.3v.2c0 1 .8 1.8 1.9 2h3.3v28.9H4.2C3 58.1 2 59 2 60s1 2 2.2 2h55.7c1.2 0 2.2-.9 2.2-2s-1.1-1.9-2.3-1.9zm-7.5-29V58H41.5V29.1h10.8zm-15 0V58H26.6V29.1h10.7zm-15 0V58H11.6V29.1h10.7zM9.8 25.2L32 7.4l22.2 17.9H9.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "school_svg__st0",
    d: "M26.2 17.9c0 3.2 2.5 5.7 5.8 5.7 3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.5-5.7-5.8-5.7-3.2 0-5.8 2.6-5.8 5.8zm5.8 1.5c-.8 0-1.6-.6-1.6-1.6 0-.8.6-1.6 1.6-1.6.8 0 1.6.6 1.6 1.6 0 .9-.7 1.6-1.6 1.6z"
  })));
};
export default SvgSchool;